module.exports = __webpack_public_path__ + "img/pancard.e5ef3469.svg";